import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// import { ReactKeycloakProvider } from "@react-keycloak/web";
// import keycloak from "./keycloak";
import { KeycloakProvider } from "./KeycloakProvider";
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <KeycloakProvider>
    <App />
  </KeycloakProvider>
  // <React.StrictMode>
  //   <ReactKeycloakProvider authClient={keycloak}>
  //     <App />
  //   </ReactKeycloakProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
